import React from "react";
import MuiTableCell from "@mui/material/TableCell";
import clsx from "clsx";

import { useStyles, useTableCellStyles } from "./TableCell.styles";
import { TableCellProps } from "./TableCell.types";

function TableCell(props: TableCellProps) {
  const { className: classNameProp, borderRight, ...other } = props;

  const tableCellclasses = useTableCellStyles();

  const classes = useStyles();

  const className = clsx(classNameProp, {
    [classes.borderRight]: borderRight,
  });

  return (
    <MuiTableCell {...other} classes={tableCellclasses} className={className} />
  );
}

export default TableCell;
